export const INGREDIENT_CARD_IMAGE_WIDTH = 230;
